import {
  Component, OnInit, Input, ChangeDetectorRef, EventEmitter, Output, ViewChild, TemplateRef,
  AfterViewInit,
  OnDestroy,
  OnChanges} from '@angular/core';
import { RelatedImageSetViewDataModel } from '../models/relatedImageSetViewDataModel';
import { ImageFile } from '../models/imageFile';
import { RelatedSetLinkingModel } from '../models/relatedSetLinkingModel';
import { LookupDataService } from '../services/lookup-data.service';
import { Router } from '@angular/router';
import { GalleryHistoryService } from '../services/gallery-history.service';
import { isTypeof } from '@microsoft/applicationinsights-core-js';
import { ImageCarouselComponent } from '../image-carousel/image-carousel.component';
import { GalleryTypeService } from '../services/gallery-type.service';
import { FilterParams } from 'starbase-launcher';
import { StarbaseModalOptions, StarbaseModalButton, StarbaseModalTypes, StarbaseModalDialogService } from 'starbase-modal-dialog';
import { ImageType } from '../models/imageType';
import { BreakpointService } from '../breakpoint.service';
import { libraryViewModes } from '../libraryViewModes';

@Component({
  selector: 'app-image-carousel-holder',
  templateUrl: './image-carousel-holder.component.html',
  styleUrls: ['./image-carousel-holder.component.css']
})
export class ImageCarouselHolderComponent implements OnInit, AfterViewInit, OnChanges {

  /**Data representing collection of all related image sets to be shown in image carousel. */
  @Input() rsvImageModels: RelatedImageSetViewDataModel[] = [];
  /**Boolean to track if image carousel will show Related image set view images or not. */
  @Input() isRSVMode = false;
  /** Data representing collection of recently viewed records */
  @Input() imageCollection: ImageFile[] = []; // collection of recently viewed records

  @Input() relatedSetCollections: RelatedSetLinkingModel[] = [];
  /** Emits when the user selects a thumbnail */
  @Output() recordSelected: EventEmitter<number> = new EventEmitter<number>();

  @Output() changePageEmitter = new EventEmitter<string>();

  @ViewChild('imageCarousel') imageCarouselComp: ImageCarouselComponent;

  @ViewChild('confirmFilterModal', { static: true }) confirmFilterModal: TemplateRef<any>;

  public open: boolean; // determines if the component is shown in "raised" (CSS class 'open')
  related = false;
  history = false;
  setName = false;
  public imageTypeFilter: ImageType = new ImageType();

  isRelatedTabEnabled = false;
  isHistoryTabEnabled = true;
  isSetNameTabEnabled = false;

  isSetNameGridMode = false;

  relevantSetImages = [];

  selectedSetName: string;
  selectedSetUID: number;
  selectedRecord: number;
  selectedRelatedImageSetName: string;

  historyToDisplay: ImageFile[] = [];
  isHandset = false;
  libViewModes = libraryViewModes;
  private _subscription;
  private defaultImgType = new ImageType();
  private currentFilters: FilterParams<ImageFile>;

  constructor(private cd: ChangeDetectorRef,
    private lookupDataSvc: LookupDataService,
    private gallerySvc: GalleryTypeService,
    private modalSvc: StarbaseModalDialogService,
    private breakpointSvc: BreakpointService) { }

  ngOnInit(): void {
    this.isHistoryTabEnabled = this.imageCollection?.length > 0 ? true : false;
    this.historyToDisplay = this.imageCollection;

    this._subscription = this.breakpointSvc.handset$.subscribe(
      isHandset => {
        this.isHandset = isHandset;
      }
    );
    //TODO: UPDATE FOR UID USE
    if(this.rsvImageModels?.length === 1){
      this.isSetNameTabEnabled = true;
      this.selectedSetName = this.rsvImageModels[0].name;
      //TODO: UPDATE TO USE RelatedImageSetViewDataModel.Relatedsetuid or find a way to clarify
      this.selectedSetUID = this.rsvImageModels[0].uid
      this.getSetDataForSelectedRelatedImageSet(this.selectedSetUID);
    }
    this.isRelatedTabEnabled = this.rsvImageModels?.length > 1 ? true : false;
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.triggerUpdate();
    }, 1000);
  }


  ngOnChanges() {
    this.ngOnInit();
  }

    /** Checks if there are already filters in the gallery service.
     * If there are, presents the user with a modal confirmation box.
     * Upon yes, sets the filters to "this" selectedRelatedImageSetName. */
  changeFilterToMe(event?): void {
    this.resetTabsToDefault();
    if (event) {
      event.stopPropagation();
    }
    console.log(event);
    this.gallerySvc.LedgerSetsMode = false;
    if (this.gallerySvc.CountOfFiltersIgnoreImageType > 0 || this.gallerySvc.HasActiveSearch) {

      const confirmFilterModal = new StarbaseModalOptions(
        'Confirm filter replacement',
        '',
        [
          new StarbaseModalButton(
            'No, keep current filters',
            () => this.modalSvc.closeModal('User chose to viewing related image set filter')
          ),
          new StarbaseModalButton(
            'Yes',
            () => {
              const fp = new FilterParams<ImageFile>();
              this.currentFilters = this.gallerySvc.getCurrentLibraryFilters();
              const galleryType = this.gallerySvc.getGalleryType();
              if (galleryType.uid && galleryType.uid > 0 && galleryType.typeOfImage !== 'All') {
                fp.replaceFilter('TypeOfImageId', galleryType.uid);
              }
              fp.addToFilter('RelatedSetUID', this.selectedSetUID);
              fp.searchPhrase = '';
              fp.page = 1;
              fp.rpp = 35;
              fp.sortFields[0] = 'SequenceNumber';
              fp.sortAsc = true;
              console.log(fp);
              this.gallerySvc.clearCurrentFilterOptions();
              this.gallerySvc.setCurrentLibraryFilters(fp);
              this.gallerySvc.storeRelatedSetNameFilter(this.selectedRelatedImageSetName);
              this.gallerySvc.clearLibraryImages();
              this.changePageEmitter.emit(this.selectedRelatedImageSetName);
              this.modalSvc.closeModal('User chose to filter by keyword');
            }
          )
        ],
        StarbaseModalTypes.Info,
        this.confirmFilterModal
      );
      confirmFilterModal.forcedWidth = this.isHandset ? '90vw' : '';
      this.modalSvc.postModal(confirmFilterModal);
    } else {
      //TODO: UPDATE TO UID
      this.currentFilters = this.gallerySvc.getCurrentLibraryFilters();
      this.currentFilters.replaceFilter('RelatedSetUID', this.selectedSetUID);
      this.currentFilters.page = 1;
      this.currentFilters.searchPhrase = '';
      this.currentFilters.rpp = 35;
      this.currentFilters.sortFields[0] = 'SequenceNumber';
      this.currentFilters.sortAsc = true;
      this.gallerySvc.setCurrentLibraryFilters(this.currentFilters);
      this.gallerySvc.storeRelatedSetNameFilter(this.selectedRelatedImageSetName);
      this.gallerySvc.clearLibraryImages();
      this.changePageEmitter.emit(this.selectedRelatedImageSetName);
    }
    return;
  }

  public triggerUpdate(): void {
    this.isSetNameTabEnabled = this.rsvImageModels?.length > 0  ? true : false;
    this.resetTabsToDefault();
    this.cd.detectChanges();
  }

  //Activate set name tab
  handleSelectImageCarouselThumbnail(data) {
    this.resetSetThumbnails();
    
    // Check if this is a RelatedImageSetViewDataModel (from related image sets tab)
    // These objects have both uid and name properties, plus imageCount, thumbnailImage, etc.
    if (data && data.name && data.imageCount !== undefined) {
      // This is a related image set thumbnail being clicked
      this.setName = true;
      this.selectedSetName = data.name;
      this.selectedSetUID = data.uid;
      this.isSetNameTabEnabled = true;
      this.related = false;
      
      this.getSetDataForSelectedRelatedImageSet(data.uid);
      
      // Store the name for display/filter purposes
      this.selectedRelatedImageSetName = data.name; // Should be the name, not UID
    } else if (data && data.uid) {
      // This is a regular image thumbnail (from recently viewed or set name tab)
      this.recordSelected.emit(data.uid);
    } else {
      console.warn('Unexpected data format in handleSelectImageCarouselThumbnail:', data);
    }
  }

  resetSetThumbnails(){
    this.relevantSetImages = [];
  }

  getSetDataForSelectedRelatedImageSet(setUID){
    this.lookupDataSvc.getRecordsInSetByNameFromServer(setUID).subscribe(s => {
      this.resetSetThumbnails();
      s.collection.forEach(rec => {
        this.relevantSetImages.push(rec.imageModel);
      });
    });
  }

  resetTabsToDefault(){
    this.isHistoryTabEnabled = this.imageCollection?.length > 0 ? true : false;
    this.history = false;

    this.isRelatedTabEnabled = this.rsvImageModels?.length > 1 ? true : false;
    this.related = false;

    this.isSetNameTabEnabled = this.rsvImageModels?.length === 1 ? true : false;
    this.setName = false;
    this.open = false;
  }

  /*
  1: Recently Viewed
  2: Related Image Sets
  3: Set Name
  0: Close everything.
  */
  toggleTabs(tabID: string) {
    //Check whether whatever came in is active or not.

    if (tabID === '0') {
      this.resetTabsToDefault();
      this.cd.markForCheck();
      return;
    }

    const isCurrentTabActive = (tabID === '1' && this.history) || (tabID === '2' && this.related) || (tabID === '3' && this.setName);

    if (tabID === '3' && !this.selectedRelatedImageSetName) {
      this.selectedRelatedImageSetName = this.selectedSetName?.length > 0 ? this.selectedSetName : '';
    }
    // If tabID is active, we wanna toggle the whole holder, hence set everything to false.
    if (isCurrentTabActive && this.open) {
      this.open = false;
      this.related = false;
      this.history = false;
      this.setName = false;
    } else { //If it isnt, we are switching tabs while we had an active tab.
      this.open = true;
      this.history = (tabID === '1');
      this.related = (tabID === '2');
      this.setName = (tabID === '3');

      //Reset setName tab booleans, and data array in case its active and we click away from it.
      // eslint-disable-next-line eqeqeq
      if(this.isSetNameTabEnabled && tabID != '3' && this.isRelatedTabEnabled){
        this.isSetNameTabEnabled = false;
        this.setName = false;
        this.selectedSetName = '';
        this.relevantSetImages = [];
      }
    }
    this.cd.markForCheck();
  }
}
